import { render } from "./LexiconComponent.vue?vue&type=template&id=3263bfd3"
import script from "./LexiconComponent.vue?vue&type=script&lang=js"
export * from "./LexiconComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__